import React, { useEffect, useState, Fragment } from 'react';
import { CalendarIcon, PlusIcon, SearchIcon, CheckCircleIcon, XCircleIcon, LockIcon, ClockIcon, CheckIcon, ChevronDownIcon, ChevronUpIcon, ArrowUpDownIcon, PrinterIcon, ListTodoIcon, PackageIcon, EditIcon, XIcon } from 'lucide-react';
import { initialProducts } from './ProductDatabase';
import { labelColors } from '../constants/labels';
type TabType = 'planning' | 'pending' | 'approved' | 'completed';
type SortDirection = 'asc' | 'desc';
interface TabItemProps {
  id: TabType;
  label: string;
  icon: React.ReactNode;
  count: number;
}
interface SortingProps {
  direction: SortDirection;
  onChange: (direction: SortDirection) => void;
}
function TabButton({
  tab,
  activeTab,
  onClick,
  icon,
  label,
  count
}: {
  tab: TabType;
  activeTab: TabType;
  onClick: (tab: TabType) => void;
  icon: React.ReactNode;
  label: string;
  count: number;
}) {
  return;
}
function SortingButton({
  direction,
  onChange
}: SortingProps) {
  return <div className="flex items-center gap-2" data-id="element-590">
      <button onClick={() => onChange(direction === 'asc' ? 'desc' : 'asc')} className="flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 rounded-lg" data-id="element-591">
        <span data-id="element-592">Datum</span>
        {direction === 'asc' ? <ChevronUpIcon className="h-4 w-4" data-id="element-593" /> : direction === 'desc' ? <ChevronDownIcon className="h-4 w-4" data-id="element-594" /> : <ArrowUpDownIcon className="h-4 w-4" data-id="element-595" />}
      </button>
    </div>;
}
function PrintLabelButton({
  label,
  quantity
}: {
  label: any;
  quantity: number;
}) {
  return <button onClick={() => {
    alert(`Drucke ${quantity}x ${label.name} in ${labelColors.find(c => c.hex === label.color)?.name}`);
  }} className="inline-flex items-center gap-1.5 px-2 py-1 text-sm bg-[#ec8301] text-white rounded hover:bg-[#ec8301]/90" data-id="element-596">
      <PrinterIcon className="h-4 w-4" data-id="element-597" />
      <span data-id="element-598">Etiketten</span>
    </button>;
}
function LabelDetailDropdown({
  label,
  isExpanded,
  onToggle
}: {
  label: {
    color: string;
    name: string;
    count: number;
    printed?: boolean;
    details?: Array<{
      productName: string;
      productNumber: string;
      quantity: number;
      labelsPerProduct: number;
    }>;
  };
  isExpanded: boolean;
  onToggle: () => void;
}) {
  return <div className="space-y-2" data-id="element-599">
      <div className={`flex items-center justify-between p-4 rounded-lg ${label.printed ? 'bg-green-50' : 'bg-gray-50'} cursor-pointer`} onClick={onToggle} data-id="element-600">
        <div className="flex items-center gap-3" data-id="element-601">
          <div className="w-6 h-6 rounded-full" style={{
          backgroundColor: label.color
        }} data-id="element-602" />
          <div data-id="element-603">
            <span className="font-medium" data-id="element-604">{label.name}</span>
            <span className="text-sm text-gray-600 ml-2" data-id="element-605">
              ({label.count} Stück)
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-606">
          {label.printed ? <span className="text-green-600 flex items-center gap-1" data-id="element-607">
              <CheckIcon className="h-5 w-5" data-id="element-608" />
              Gedruckt
            </span> : <span className="text-gray-500" data-id="element-609">Warten...</span>}
          <ChevronDownIcon className={`h-5 w-5 transition-transform ${isExpanded ? 'transform rotate-180' : ''}`} data-id="element-610" />
        </div>
      </div>
      {isExpanded && label.details && <div className="ml-8 bg-white rounded-lg border border-gray-200" data-id="element-611">
          <table className="w-full text-sm" data-id="element-612">
            <thead className="bg-gray-50" data-id="element-613">
              <tr data-id="element-614">
                <th className="px-4 py-2 text-left font-medium text-gray-600" data-id="element-615">
                  Produkt
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600" data-id="element-616">
                  Menge
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600" data-id="element-617">
                  Etiketten
                </th>
                <th className="px-4 py-2 text-right font-medium text-gray-600" data-id="element-618">
                  Aktion
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-619">
              {label.details.map((detail, idx) => <tr key={idx} data-id="element-620">
                  <td className="px-4 py-2" data-id="element-621">
                    <div data-id="element-622">
                      <div data-id="element-623">{detail.productName}</div>
                      <div className="text-xs text-gray-500" data-id="element-624">
                        {detail.productNumber}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-2" data-id="element-625">{detail.quantity}</td>
                  <td className="px-4 py-2" data-id="element-626">
                    {detail.quantity * detail.labelsPerProduct}
                  </td>
                  <td className="px-4 py-2 text-right" data-id="element-627">
                    <button onClick={e => {
                e.stopPropagation();
                alert(`Nachdrucken von ${detail.quantity * detail.labelsPerProduct} Etiketten für ${detail.productName}`);
              }} className="inline-flex items-center gap-1.5 px-2 py-1 text-sm bg-[#ec8301] text-white rounded hover:bg-[#ec8301]/90" data-id="element-628">
                      <PrinterIcon className="h-4 w-4" data-id="element-629" />
                      <span data-id="element-630">Nachdrucken</span>
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
}
function LoadingModal({
  isOpen,
  message,
  sortedLabels = null,
  onPrintConfirm = null,
  onComplete = null,
  plan = null
}: {
  isOpen: boolean;
  message: string;
  sortedLabels?: {
    color: string;
    name: string;
    count: number;
    printed?: boolean;
    details?: Array<{
      productName: string;
      productNumber: string;
      quantity: number;
      labelsPerProduct: number;
    }>;
  }[] | null;
  onPrintConfirm?: (color: string) => void;
  onComplete?: (completedPlan?: any) => void;
  plan?: any;
}) {
  const [currentPrintingColor, setCurrentPrintingColor] = useState<string | null>(null);
  const [showPrintButton, setShowPrintButton] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [completionProgress, setCompletionProgress] = useState(0);
  const [expandedLabels, setExpandedLabels] = useState<string[]>([]);
  const [printingPlans, setPrintingPlans] = useState<string[]>([]);
  useEffect(() => {
    if (sortedLabels) {
      const nextColor = sortedLabels.find(l => !l.printed)?.color || null;
      setCurrentPrintingColor(nextColor);
      setShowPrintButton(false);
      if (sortedLabels.every(l => l.printed)) {
        setIsCompleted(true);
        let progress = 0;
        const interval = setInterval(() => {
          progress += 2;
          setCompletionProgress(progress);
          if (progress >= 100) {
            clearInterval(interval);
            setTimeout(() => {
              if (plan) {
                const completedPlan = {
                  ...plan,
                  completedAt: new Date().toISOString(),
                  status: 'completed'
                };
                onComplete?.(completedPlan);
              } else {
                onComplete?.();
              }
            }, 500);
          }
        }, 20); // Make the progress faster
        return () => clearInterval(interval);
      }
    }
  }, [sortedLabels, plan, onComplete]);
  if (!isOpen) return null;
  const currentLabel = sortedLabels?.find(l => l.color === currentPrintingColor);
  const colorName = labelColors.find(c => c.hex === currentPrintingColor)?.name;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-631">
      <div className="bg-white rounded-lg p-6 w-[600px] max-h-[80vh] overflow-y-auto" data-id="element-632">
        {isCompleted ? <div className="space-y-4" data-id="element-633">
            <div className="flex items-center justify-center" data-id="element-634">
              <CheckIcon className="h-12 w-12 text-green-500" data-id="element-635" />
            </div>
            <p className="text-center text-lg font-medium text-gray-900" data-id="element-636">
              Alle Etiketten wurden erfolgreich gedruckt!
            </p>
            <p className="text-center text-gray-600" data-id="element-637">
              Der Auftrag wird in die Produktion übergeben...
            </p>
            <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-638">
              <div className="bg-green-500 h-2 rounded-full transition-all duration-100" style={{
            width: `${completionProgress}%`
          }} data-id="element-639"></div>
            </div>
          </div> : !sortedLabels ? <div className="space-y-4" data-id="element-640">
            <div className="flex items-center justify-center" data-id="element-641">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#ec8301]" data-id="element-642"></div>
            </div>
            <p className="text-center text-gray-700" data-id="element-643">{message}</p>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-644">
              <div className="bg-[#ec8301] h-2.5 rounded-full animate-[loading_2s_ease-in-out_infinite]" style={{
            width: '100%'
          }} data-id="element-645"></div>
            </div>
          </div> : <div className="space-y-6" data-id="element-646">
            <div data-id="element-647">
              <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-648">
                Etiketten-Druckassistent
              </h3>
              <p className="text-sm text-gray-500" data-id="element-649">
                Folgen Sie den Anweisungen zum Drucken der Etiketten
              </p>
            </div>
            {currentPrintingColor && <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4" data-id="element-650">
                <div className="flex items-center gap-3 mb-4" data-id="element-651">
                  <div className="w-8 h-8 rounded-full" style={{
              backgroundColor: currentPrintingColor
            }} data-id="element-652"></div>
                  <div className="flex-1" data-id="element-653">
                    <h4 className="font-medium text-gray-900" data-id="element-654">
                      Aktueller Druckvorgang: {colorName}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-655">
                      {currentLabel?.count} Etiketten
                    </p>
                  </div>
                </div>
                <div className="space-y-4" data-id="element-656">
                  <div className="bg-white rounded p-3 text-gray-700" data-id="element-657">
                    <p className="font-medium mb-1" data-id="element-658">Anweisung:</p>
                    <p data-id="element-659">
                      Bitte legen Sie {colorName}e Etiketten in den Drucker ein.
                    </p>
                  </div>
                  {!showPrintButton ? <button onClick={() => setShowPrintButton(true)} className="w-full bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 flex items-center justify-center gap-2" data-id="element-660">
                      <CheckIcon className="h-5 w-5" data-id="element-661" />
                      Etiketten eingelegt
                    </button> : <button onClick={() => {
              onPrintConfirm?.(currentPrintingColor);
              setShowPrintButton(false);
            }} className="w-full bg-[#ec8301] text-white px-4 py-2 rounded-lg hover:bg-[#ec8301]/90 flex items-center justify-center gap-2" data-id="element-662">
                      <PrinterIcon className="h-5 w-5" data-id="element-663" />
                      Druckvorgang starten ({currentLabel?.count} Etiketten)
                    </button>}
                </div>
              </div>}
            <div className="space-y-3" data-id="element-664">
              {sortedLabels.map((label, index) => <LabelDetailDropdown key={index} label={label} isExpanded={expandedLabels.includes(label.color)} onToggle={() => {
            setExpandedLabels(prev => prev.includes(label.color) ? prev.filter(c => c !== label.color) : [...prev, label.color]);
          }} data-id="element-665" />)}
            </div>
            <div className="border-t pt-4 mt-4" data-id="element-666">
              <div className="flex justify-between items-center" data-id="element-667">
                <div className="text-sm" data-id="element-668">
                  <span className="font-medium" data-id="element-669">
                    Gesamt zu druckende Etiketten:{' '}
                  </span>
                  <span className="font-bold text-[#ec8301]" data-id="element-670">
                    {sortedLabels.reduce((sum, label) => sum + label.count, 0)}{' '}
                    Stück
                  </span>
                </div>
                <div className="text-sm text-gray-600" data-id="element-671">
                  {sortedLabels.filter(l => l.printed).length} von{' '}
                  {sortedLabels.length} Farben gedruckt
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}
function ProductionPlanning() {
  const [activeTab, setActiveTab] = useState<TabType>('planning');
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc');
  const [currentPlan, setCurrentPlan] = useState<ProductionPlan>({
    date: new Date(Date.now() + 86400000).toISOString().split('T')[0],
    items: [],
    status: 'draft'
  });
  const [pendingPlans, setPendingPlans] = useState<ProductionPlan[]>([]);
  const [approvedPlans, setApprovedPlans] = useState<ProductionPlan[]>([]);
  const [completedPlans, setCompletedPlans] = useState<ProductionPlan[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState<(typeof initialProducts)[0] | null>(null);
  const [quantity, setQuantity] = useState<string>('1');
  const [isUserApprover] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingState, setLoadingState] = useState<{
    isOpen: boolean;
    message: string;
    sortedLabels: null | Array<{
      color: string;
      name: string;
      count: number;
      printed?: boolean;
      details?: Array<{
        productName: string;
        productNumber: string;
        quantity: number;
        labelsPerProduct: number;
      }>;
    }>;
    expandedRow: number | null;
  }>({
    isOpen: false,
    message: '',
    sortedLabels: null,
    expandedRow: null
  });
  const [verifyAction, setVerifyAction] = useState<'edit' | 'advance' | 'delete' | null>(null);
  const [editingPlan, setEditingPlan] = useState<any>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [printingPlans, setPrintingPlans] = useState<string[]>([]);
  const sortPlans = (plansToSort: ProductionPlan[]) => {
    return [...plansToSort].sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    });
  };
  const filteredProducts = initialProducts.filter(product => product.name.toLowerCase().includes(searchTerm.toLowerCase()) || product.productNumber.toLowerCase().includes(searchTerm.toLowerCase()));
  const addToPlan = () => {
    if (selectedProduct && parseInt(quantity) > 0) {
      setCurrentPlan(prev => ({
        ...prev,
        items: [...prev.items, {
          product: selectedProduct,
          quantity: parseInt(quantity),
          status: 'pending'
        }]
      }));
      setSelectedProduct(null);
      setQuantity('1');
    }
  };
  const removeFromPlan = (index: number) => {
    setCurrentPlan(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };
  const submitForApproval = () => {
    if (currentPlan.items.length === 0) return;
    const planForApproval = {
      ...currentPlan,
      status: 'pending_approval' as const,
      submittedAt: new Date().toISOString()
    };
    setPendingPlans(prev => [...prev, planForApproval]);
    setActiveTab('pending');
    setCurrentPlan({
      date: new Date(Date.now() + 86400000).toISOString().split('T')[0],
      items: [],
      status: 'draft'
    });
  };
  const approvePlan = (planToApprove: ProductionPlan) => {
    const approvedPlan = {
      ...planToApprove,
      status: 'approved' as const,
      approvedBy: 'Max Mustermann',
      approvedAt: new Date().toISOString()
    };
    setApprovedPlans(prev => [...prev, approvedPlan]);
    setPendingPlans(prev => prev.filter(p => p !== planToApprove));
    setActiveTab('approved');
  };
  const rejectPlan = (planToReject: ProductionPlan) => {
    const rejectedPlan = {
      ...planToReject,
      status: 'rejected' as const,
      rejectedBy: 'Max Mustermann',
      rejectedAt: new Date().toISOString()
    };
    setCurrentPlan(rejectedPlan);
    setPendingPlans(prev => prev.filter(p => p !== planToReject));
    setActiveTab('planning');
  };
  const handlePrintAllLabels = (plan: any) => {
    setPrintingPlans(prev => [...prev, plan.date]); // Add plan to printing list
    setIsLoading(true);
    setTimeout(() => {
      const groupedByColor = plan.items.filter((item: any) => item.product.label).reduce((acc: any, item: any) => {
        const color = item.product.label.color;
        const colorName = labelColors.find(c => c.hex === color)?.name || '';
        if (!acc[color]) {
          acc[color] = {
            color: color,
            name: colorName,
            count: 0,
            printed: false,
            details: []
          };
        }
        const labelCount = item.quantity * (item.product.labelsPerProduct || 1);
        acc[color].count += labelCount;
        acc[color].details.push({
          productName: item.product.name,
          productNumber: item.product.productNumber,
          quantity: item.quantity,
          labelsPerProduct: item.product.labelsPerProduct || 1
        });
        return acc;
      }, {});
      const sortedLabels = Object.values(groupedByColor).sort((a: any, b: any) => b.count - a.count);
      setTimeout(() => {
        setIsLoading(false);
        setLoadingState({
          isOpen: true,
          message: '',
          sortedLabels,
          expandedRow: null
        });
      }, 2000);
    }, 2000);
  };
  const handlePrintConfirm = (color: string) => {
    setLoadingState(prev => {
      if (!prev.sortedLabels) return prev;
      const updatedLabels = prev.sortedLabels.map(label => label.color === color ? {
        ...label,
        printed: true
      } : label);
      const nextColor = updatedLabels.find(l => !l.printed)?.color || null;
      return {
        ...prev,
        sortedLabels: updatedLabels,
        currentPrintingColor: nextColor
      };
    });
  };
  const tabs: TabItemProps[] = [{
    id: 'planning',
    label: 'Planung',
    icon: <CalendarIcon className="h-5 w-5" data-id="element-672" />,
    count: currentPlan.items.length
  }, {
    id: 'pending',
    label: 'Geplant',
    icon: <ListTodoIcon className="h-5 w-5" data-id="element-673" />,
    count: pendingPlans.length
  }, {
    id: 'approved',
    label: 'Drucken',
    icon: <PackageIcon className="h-5 w-5" data-id="element-674" />,
    count: approvedPlans.length
  }, {
    id: 'production',
    label: 'Produktion',
    icon: <PrinterIcon className="h-5 w-5" data-id="element-675" />,
    count: completedPlans.length
  }];
  const renderContent = () => {
    switch (activeTab) {
      case 'planning':
        return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-676">
            <div className="bg-white rounded-lg shadow p-4" data-id="element-677">
              <div className="relative" data-id="element-678">
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-679" />
                <input type="text" placeholder="Produkt suchen..." className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ec8301]" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-680" />
              </div>
              <div className="border border-gray-200 rounded-lg max-h-[calc(100vh-400px)] overflow-y-auto" data-id="element-681">
                {filteredProducts.map(product => <button key={product.id} onClick={() => setSelectedProduct(product)} className={`w-full text-left p-2 hover:bg-gray-50 flex items-center gap-2 ${selectedProduct?.id === product.id ? 'bg-gray-100' : ''}`} data-id="element-682">
                    <span className="font-medium" data-id="element-683">{product.name}</span>
                    <span className="text-sm text-gray-500" data-id="element-684">
                      {product.productNumber}
                    </span>
                  </button>)}
              </div>
              {selectedProduct && <div className="space-y-3 border-t border-gray-200 pt-3" data-id="element-685">
                  <div data-id="element-686">
                    <label className="block text-sm font-medium mb-1" data-id="element-687">
                      Menge
                    </label>
                    <input type="number" min="1" value={quantity} onChange={e => setQuantity(e.target.value)} className="w-full border border-gray-300 rounded-lg p-2" data-id="element-688" />
                  </div>
                  <button onClick={addToPlan} className="w-full bg-[#ec8301] text-white rounded-lg px-4 py-2 flex items-center justify-center gap-2" data-id="element-689">
                    <PlusIcon className="h-5 w-5" data-id="element-690" />
                    <span data-id="element-691">Hinzufügen</span>
                  </button>
                </div>}
            </div>
            <div className="lg:col-span-2 bg-white rounded-lg shadow p-4" data-id="element-692">
              <div className="space-y-4" data-id="element-693">
                <div className="flex justify-between items-start" data-id="element-694">
                  <div className="space-y-2" data-id="element-695">
                    <h2 className="text-lg font-medium" data-id="element-696">Produktionsplan</h2>
                    <div className="flex items-center gap-3" data-id="element-697">
                      <div data-id="element-698">
                        <label className="block text-sm text-gray-600 mb-1" data-id="element-699">
                          Datum
                        </label>
                        <input type="date" value={currentPlan.date} onChange={e => setCurrentPlan(prev => ({
                        ...prev,
                        date: e.target.value
                      }))} className="border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]" min={new Date().toISOString().split('T')[0]} data-id="element-700" />
                      </div>
                    </div>
                  </div>
                  <button onClick={submitForApproval} className="bg-[#ec8301] text-white rounded-lg px-4 py-2 flex items-center gap-2 hover:bg-[#ec8301]/90" disabled={currentPlan.items.length === 0} data-id="element-701">
                    <LockIcon className="h-5 w-5" data-id="element-702" />
                    <span data-id="element-703">Speichern</span>
                  </button>
                </div>
                {currentPlan.status !== 'draft' && <div className={`mb-4 p-2 rounded-lg ${currentPlan.status === 'approved' ? 'bg-green-100 text-green-800' : currentPlan.status === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-704">
                    {currentPlan.status === 'approved' && <div className="flex items-center gap-2" data-id="element-705">
                        <CheckCircleIcon className="h-5 w-5" data-id="element-706" />
                        <span data-id="element-707">Freigegeben von {currentPlan.approvedBy}</span>
                      </div>}
                    {currentPlan.status === 'rejected' && <div className="flex items-center gap-2" data-id="element-708">
                        <XCircleIcon className="h-5 w-5" data-id="element-709" />
                        <span data-id="element-710">Abgelehnt</span>
                      </div>}
                    {currentPlan.status === 'pending_approval' && <div className="flex items-center gap-2" data-id="element-711">
                        <LockIcon className="h-5 w-5" data-id="element-712" />
                        <span data-id="element-713">Warte auf Freigabe</span>
                      </div>}
                  </div>}
                {currentPlan.items.length === 0 ? <div className="text-center text-gray-500 py-8" data-id="element-714">
                    Noch keine Produkte im Plan
                  </div> : <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-715">
                    <table className="w-full" data-id="element-716">
                      <thead className="bg-gray-50" data-id="element-717">
                        <tr data-id="element-718">
                          <th className="px-4 py-2 text-left text-sm font-medium text-gray-600" data-id="element-719">
                            Produkt
                          </th>
                          <th className="px-4 py-2 text-left text-sm font-medium text-gray-600" data-id="element-720">
                            Menge
                          </th>
                          <th className="px-4 py-2 text-right text-sm font-medium text-gray-600" data-id="element-721"></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-722">
                        {currentPlan.items.map((item, index) => <tr key={index} data-id="element-723">
                            <td className="px-4 py-3" data-id="element-724">
                              <div data-id="element-725">
                                <div className="font-medium" data-id="element-726">
                                  {item.product.name}
                                </div>
                                <div className="text-sm text-gray-500" data-id="element-727">
                                  {item.product.productNumber}
                                </div>
                              </div>
                            </td>
                            <td className="px-4 py-3 text-sm" data-id="element-728">
                              {item.quantity}
                            </td>
                            <td className="px-4 py-3 text-right" data-id="element-729">
                              {currentPlan.status === 'draft' && <button onClick={() => removeFromPlan(index)} className="text-red-500 hover:text-red-700" data-id="element-730">
                                  <XCircleIcon className="h-5 w-5" data-id="element-731" />
                                </button>}
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>}
              </div>
            </div>
          </div>;
      case 'pending':
        return <div className="space-y-2" data-id="element-732">
            {pendingPlans.length === 0 ? <div className="text-center text-gray-500 py-8" data-id="element-733">
                Keine Pläne warten auf Freigabe
              </div> : pendingPlans.map((plan, index) => <div key={index} className="bg-white rounded-lg shadow" data-id="element-734">
                  <div className="px-4 py-3 border-b border-gray-200" data-id="element-735">
                    <div className="flex justify-between items-center" data-id="element-736">
                      <div className="flex items-center gap-4" data-id="element-737">
                        <div data-id="element-738">
                          <h3 className="font-medium flex items-center gap-2" data-id="element-739">
                            <CalendarIcon className="h-4 w-4 text-gray-400" data-id="element-740" />
                            {new Date(plan.date).toLocaleDateString('de-DE', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                          </h3>
                          <p className="text-sm text-gray-500" data-id="element-741">
                            Eingereicht:{' '}
                            {new Date(plan.submittedAt!).toLocaleDateString('de-DE', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                          </p>
                        </div>
                        <div className="bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-742">
                          {plan.items.reduce((sum, item) => sum + item.quantity, 0)}{' '}
                          Produkte
                        </div>
                      </div>
                      <div className="flex gap-2" data-id="element-743">
                        <button onClick={() => {
                    setVerifyAction('edit');
                    setEditingPlan(plan);
                  }} className="bg-[#ec8301] text-white rounded-lg px-3 py-1.5 text-sm flex items-center gap-1 hover:bg-[#ec8301]/90" data-id="element-744">
                          <EditIcon className="h-4 w-4" data-id="element-745" />
                          <span className="hidden sm:inline" data-id="element-746">Bearbeiten</span>
                        </button>
                        <button onClick={() => {
                    setVerifyAction('advance');
                    setEditingPlan(plan);
                  }} className="bg-green-500 text-white rounded-lg px-3 py-1.5 text-sm flex items-center gap-1 hover:bg-green-600" data-id="element-747">
                          <CheckCircleIcon className="h-4 w-4" data-id="element-748" />
                          <span className="hidden sm:inline" data-id="element-749">
                            Manuell vorziehen
                          </span>
                        </button>
                        <button onClick={() => {
                    setVerifyAction('delete');
                    setEditingPlan(plan);
                  }} className="bg-red-500 text-white rounded-lg px-3 py-1.5 text-sm flex items-center gap-1 hover:bg-red-600" data-id="element-750">
                          <XCircleIcon className="h-4 w-4" data-id="element-751" />
                          <span className="hidden sm:inline" data-id="element-752">Löschen</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-2 max-h-48 overflow-y-auto" data-id="element-753">
                    <table className="w-full text-sm" data-id="element-754">
                      <tbody className="divide-y divide-gray-100" data-id="element-755">
                        {plan.items.map((item, itemIndex) => <tr key={itemIndex} className="hover:bg-gray-50" data-id="element-756">
                            <td className="py-2" data-id="element-757">
                              <div className="flex items-center gap-2" data-id="element-758">
                                <div className="font-medium" data-id="element-759">
                                  {item.product.name}
                                </div>
                                <div className="text-gray-500" data-id="element-760">
                                  {item.product.productNumber}
                                </div>
                              </div>
                            </td>
                            <td className="py-2 text-right" data-id="element-761">
                              {item.quantity} Stück
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>)}
          </div>;
      case 'approved':
        return <div className="space-y-4" data-id="element-762">
            <LoadingModal isOpen={isLoading || loadingState.isOpen} message={isLoading ? 'Sortiere Etiketten nach Farbe...' : ''} sortedLabels={loadingState.sortedLabels} onPrintConfirm={handlePrintConfirm} onComplete={completedPlan => {
            if (completedPlan) {
              setCompletedPlans(prev => [...prev, completedPlan]);
              setApprovedPlans(prev => prev.filter(p => p !== completedPlan));
              setActiveTab('production');
            }
            setLoadingState(prev => ({
              ...prev,
              isOpen: false,
              sortedLabels: null
            }));
          }} plan={editingPlan} data-id="element-763" />
            {approvedPlans.length === 0 ? <div className="text-center text-gray-500 py-8" data-id="element-764">
                Keine freigegebenen Pläne vorhanden
              </div> : approvedPlans.map((plan, index) => <div key={index} className="border border-green-200 rounded-lg overflow-hidden" data-id="element-765">
                  <div className="bg-green-50 px-4 py-2 flex justify-between items-center" data-id="element-766">
                    <div data-id="element-767">
                      <span className="font-medium" data-id="element-768">
                        Produktionsplan für{' '}
                        {new Date(plan.date).toLocaleDateString('de-DE')}
                      </span>
                      <div className="text-sm text-gray-600" data-id="element-769">
                        Freigegeben von {plan.approvedBy}
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-770">
                      <button onClick={() => handlePrintAllLabels(plan)} className="bg-[#ec8301] text-white rounded-lg px-4 py-2 flex items-center gap-2 hover:bg-[#ec8301]/90" data-id="element-771">
                        <PrinterIcon className="h-5 w-5" data-id="element-772" />
                        <span data-id="element-773">Alle Etiketten drucken</span>
                      </button>
                      <div className="flex items-center gap-2 text-green-700" data-id="element-774">
                        <CheckCircleIcon className="h-5 w-5" data-id="element-775" />
                        <span className="text-sm font-medium" data-id="element-776">Freigegeben</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4" data-id="element-777">
                    <table className="w-full" data-id="element-778">
                      <thead className="bg-gray-50" data-id="element-779">
                        <tr data-id="element-780">
                          <th className="px-4 py-2 text-left text-sm font-medium text-gray-600" data-id="element-781">
                            Produkt
                          </th>
                          <th className="px-4 py-2 text-left text-sm font-medium text-gray-600" data-id="element-782">
                            Menge
                          </th>
                          <th className="px-4 py-2 text-left text-sm font-medium text-gray-600" data-id="element-783">
                            Etikett
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-784">
                        {plan.items.map((item, itemIndex) => <Fragment key={itemIndex} data-id="element-785">
                            <tr className="cursor-pointer hover:bg-gray-50" onClick={() => {
                      const newSortedLabels = [...(loadingState.sortedLabels || [])];
                      const labelIndex = newSortedLabels.findIndex(l => l.color === item.product.label?.color);
                      if (labelIndex !== -1) {
                        setLoadingState(prev => ({
                          ...prev,
                          expandedRow: itemIndex === prev.expandedRow ? null : itemIndex
                        }));
                      }
                    }} data-id="element-786">
                              <td className="px-4 py-3" data-id="element-787">
                                <div data-id="element-788">
                                  <div className="font-medium" data-id="element-789">
                                    {item.product.name}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-790">
                                    {item.product.productNumber}
                                  </div>
                                </div>
                              </td>
                              <td className="px-4 py-3 text-sm" data-id="element-791">
                                {item.quantity}
                              </td>
                              <td className="px-4 py-3" data-id="element-792">
                                {item.product.label ? <div className="flex items-center gap-2" data-id="element-793">
                                    <div className="w-4 h-4 rounded-full" style={{
                            backgroundColor: item.product.label.color
                          }} data-id="element-794" />
                                    <span className="text-sm" data-id="element-795">
                                      {item.product.label.name} (
                                      {labelColors.find(c => c.hex === item.product.label?.color)?.name}
                                      )
                                    </span>
                                  </div> : <span className="text-sm text-gray-500" data-id="element-796">
                                    Kein Etikett
                                  </span>}
                              </td>
                            </tr>
                            {loadingState.expandedRow === itemIndex && <tr data-id="element-797">
                                <td colSpan={3} className="p-0" data-id="element-798">
                                  <ProductDetailRow item={item} onPrint={(product, quantity) => {
                          setLoadingState(prev => ({
                            ...prev,
                            isOpen: true,
                            sortedLabels: [{
                              color: product.label.color,
                              name: labelColors.find(c => c.hex === product.label.color)?.name || '',
                              count: quantity,
                              printed: false
                            }],
                            currentPrintingColor: product.label.color
                          }));
                        }} data-id="element-799" />
                                </td>
                              </tr>}
                          </Fragment>)}
                        <tr className="bg-gray-50" data-id="element-800">
                          <td className="px-4 py-3 font-medium" data-id="element-801">Gesamt</td>
                          <td className="px-4 py-3 text-sm" data-id="element-802">
                            {plan.items.reduce((sum, item) => sum + item.quantity, 0)}{' '}
                            Stück
                          </td>
                          <td data-id="element-803"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>)}
          </div>;
      case 'production':
        return <div className="space-y-4" data-id="element-804">
            {completedPlans.length === 0 ? <div className="text-center text-gray-500 py-8" data-id="element-805">
                Keine Produktionsaufträge vorhanden
              </div> : completedPlans.map((plan, index) => <div key={index} className="bg-white rounded-lg shadow" data-id="element-806">
                  <div className="px-4 py-3 border-b border-gray-200" data-id="element-807">
                    <div className="flex justify-between items-center" data-id="element-808">
                      <div className="flex items-center gap-4" data-id="element-809">
                        <div data-id="element-810">
                          <h3 className="font-medium flex items-center gap-2" data-id="element-811">
                            <CalendarIcon className="h-4 w-4 text-gray-400" data-id="element-812" />
                            {new Date(plan.date).toLocaleDateString('de-DE', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                          </h3>
                          <p className="text-sm text-gray-500" data-id="element-813">
                            Etiketten gedruckt:{' '}
                            {new Date(plan.completedAt || '').toLocaleDateString('de-DE', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                          </p>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-814">
                          <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-815">
                            <CheckIcon className="h-4 w-4" data-id="element-816" />
                            Etiketten gedruckt
                          </div>
                          <div className="bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-817">
                            {plan.items.reduce((sum, item) => sum + item.quantity, 0)}{' '}
                            Produkte
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-2" data-id="element-818">
                    <table className="w-full text-sm" data-id="element-819">
                      <thead className="bg-gray-50" data-id="element-820">
                        <tr data-id="element-821">
                          <th className="px-4 py-2 text-left font-medium text-gray-600" data-id="element-822">
                            Produkt
                          </th>
                          <th className="px-4 py-2 text-left font-medium text-gray-600" data-id="element-823">
                            Menge
                          </th>
                          <th className="px-4 py-2 text-left font-medium text-gray-600" data-id="element-824">
                            Etiketten
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-825">
                        {plan.items.map((item, itemIndex) => <tr key={itemIndex} className="hover:bg-gray-50" data-id="element-826">
                            <td className="px-4 py-3" data-id="element-827">
                              <div data-id="element-828">
                                <div className="font-medium" data-id="element-829">
                                  {item.product.name}
                                </div>
                                <div className="text-sm text-gray-500" data-id="element-830">
                                  {item.product.productNumber}
                                </div>
                              </div>
                            </td>
                            <td className="px-4 py-3" data-id="element-831">{item.quantity} Stück</td>
                            <td className="px-4 py-3" data-id="element-832">
                              <div className="flex items-center gap-2" data-id="element-833">
                                <div className="w-4 h-4 rounded-full" style={{
                          backgroundColor: item.product.label?.color
                        }} data-id="element-834" />
                                <span data-id="element-835">
                                  {item.quantity * (item.product.labelsPerProduct || 1)}{' '}
                                  Etiketten
                                </span>
                              </div>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>)}
          </div>;
      default:
        return null;
    }
  };
  const handleVerificationSuccess = () => {
    if (verifyAction === 'edit') {
      setShowEditModal(true);
      setVerifyAction(null);
    } else if (verifyAction === 'advance') {
      const planToAdvance = {
        ...editingPlan,
        status: 'approved',
        approvedBy: 'Max Mustermann',
        approvedAt: new Date().toISOString()
      };
      setApprovedPlans(prev => [...prev, planToAdvance]);
      setPendingPlans(prev => prev.filter(p => p !== editingPlan));
      setVerifyAction(null);
      setEditingPlan(null);
      setActiveTab('approved');
    } else if (verifyAction === 'delete') {
      setPendingPlans(prev => prev.filter(p => p !== editingPlan));
      setVerifyAction(null);
      setEditingPlan(null);
    }
  };
  return <div className="p-6 h-full space-y-6" data-id="element-836">
      <header className="mb-8" data-id="element-837">
        <h1 className="text-3xl font-bold text-[#e20019]" data-id="element-838">
          Produktionsplanung
        </h1>
        <p className="text-gray-600" data-id="element-839">Verwalten Sie Ihre Produktionspläne</p>
      </header>
      <div className="bg-white rounded-lg shadow" data-id="element-840">
        <div className="border-b border-gray-200" data-id="element-841">
          <div className="flex gap-2 p-2" data-id="element-842">
            {tabs.map(tab => <TabButton key={tab.id} tab={tab.id} activeTab={activeTab} onClick={tab => {
            setActiveTab(tab);
            setSortDirection('desc');
          }} icon={tab.icon} label={tab.label} count={tab.count} data-id="element-843" />)}
          </div>
        </div>
        <div className="p-4" data-id="element-844">{renderContent()}</div>
      </div>
      <CodeVerificationModal isOpen={!!verifyAction} onClose={() => {
      setVerifyAction(null);
      setEditingPlan(null);
    }} action={verifyAction!} onConfirm={handleVerificationSuccess} data-id="element-845" />
      <EditPlanModal isOpen={showEditModal} onClose={() => {
      setShowEditModal(false);
      setEditingPlan(null);
    }} plan={editingPlan} onSave={updatedPlan => {
      setPendingPlans(prev => prev.map(p => p === editingPlan ? updatedPlan : p));
      setShowEditModal(false);
      setEditingPlan(null);
    }} data-id="element-846" />
    </div>;
}
function EditPlanModal({
  isOpen,
  onClose,
  plan,
  onSave
}: {
  isOpen: boolean;
  onClose: () => void;
  plan: any;
  onSave: (updatedPlan: any) => void;
}) {
  const [editedPlan, setEditedPlan] = useState(plan || {
    date: new Date().toISOString().split('T')[0],
    items: [],
    status: 'draft'
  });
  const [selectedProduct, setSelectedProduct] = useState<null | (typeof initialProducts)[0]>(null);
  const [quantity, setQuantity] = useState<string>('1');
  const [searchTerm, setSearchTerm] = useState('');
  // Update editedPlan when plan changes
  useEffect(() => {
    if (plan) {
      setEditedPlan(plan);
    }
  }, [plan]);
  const filteredProducts = initialProducts.filter(product => product.name.toLowerCase().includes(searchTerm.toLowerCase()) || product.productNumber.toLowerCase().includes(searchTerm.toLowerCase()));
  if (!isOpen || !plan) return null;
  const updateItemQuantity = (index: number, newQuantity: number) => {
    const updatedItems = [...editedPlan.items];
    updatedItems[index] = {
      ...updatedItems[index],
      quantity: newQuantity
    };
    setEditedPlan({
      ...editedPlan,
      items: updatedItems
    });
  };
  const removeItem = (index: number) => {
    const updatedItems = editedPlan.items.filter((_, i) => i !== index);
    setEditedPlan({
      ...editedPlan,
      items: updatedItems
    });
  };
  const addProduct = () => {
    if (selectedProduct && parseInt(quantity) > 0) {
      setEditedPlan({
        ...editedPlan,
        items: [...editedPlan.items, {
          product: selectedProduct,
          quantity: parseInt(quantity),
          status: 'pending'
        }]
      });
      setSelectedProduct(null);
      setQuantity('1');
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-847">
      <div className="bg-white rounded-lg p-6 w-[800px] max-h-[80vh] overflow-auto" data-id="element-848">
        <div className="flex justify-between items-center mb-6" data-id="element-849">
          <h2 className="text-xl font-bold" data-id="element-850">Produktionsplan bearbeiten</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-851">
            <XIcon className="h-5 w-5" data-id="element-852" />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-6" data-id="element-853">
          {/* Left column - Product selection */}
          <div data-id="element-854">
            <h3 className="text-lg font-medium mb-4" data-id="element-855">Produkt hinzufügen</h3>
            <div className="space-y-4" data-id="element-856">
              <div className="relative" data-id="element-857">
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-858" />
                <input type="text" placeholder="Produkt suchen..." className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ec8301]" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-859" />
              </div>
              <div className="border border-gray-200 rounded-lg max-h-[300px] overflow-y-auto" data-id="element-860">
                {filteredProducts.map(product => <button key={product.id} onClick={() => setSelectedProduct(product)} className={`w-full text-left p-2 hover:bg-gray-50 flex items-center gap-2 ${selectedProduct?.id === product.id ? 'bg-gray-100' : ''}`} data-id="element-861">
                    <span className="font-medium" data-id="element-862">{product.name}</span>
                    <span className="text-sm text-gray-500" data-id="element-863">
                      {product.productNumber}
                    </span>
                  </button>)}
              </div>
              {selectedProduct && <div className="space-y-3 border-t border-gray-200 pt-3" data-id="element-864">
                  <div data-id="element-865">
                    <label className="block text-sm font-medium mb-1" data-id="element-866">
                      Menge
                    </label>
                    <input type="number" min="1" value={quantity} onChange={e => setQuantity(e.target.value)} className="w-full border border-gray-300 rounded-lg p-2" data-id="element-867" />
                  </div>
                  <button onClick={addProduct} className="w-full bg-[#ec8301] text-white rounded-lg px-4 py-2 flex items-center justify-center gap-2" data-id="element-868">
                    <PlusIcon className="h-5 w-5" data-id="element-869" />
                    <span data-id="element-870">Hinzufügen</span>
                  </button>
                </div>}
            </div>
          </div>
          {/* Right column - Current items */}
          <div data-id="element-871">
            <h3 className="text-lg font-medium mb-4" data-id="element-872">Aktuelle Produkte</h3>
            <div className="space-y-3" data-id="element-873">
              {editedPlan.items.map((item: any, index: number) => <div key={index} className="border border-gray-200 rounded-lg p-3 space-y-2" data-id="element-874">
                  <div className="flex justify-between items-start" data-id="element-875">
                    <div data-id="element-876">
                      <div className="font-medium" data-id="element-877">{item.product.name}</div>
                      <div className="text-sm text-gray-500" data-id="element-878">
                        {item.product.productNumber}
                      </div>
                    </div>
                    <button onClick={() => removeItem(index)} className="text-red-500 hover:text-red-700" data-id="element-879">
                      <XIcon className="h-5 w-5" data-id="element-880" />
                    </button>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-881">
                    <input type="number" min="1" value={item.quantity} onChange={e => updateItemQuantity(index, parseInt(e.target.value) || 0)} className="w-32 border border-gray-300 rounded-lg p-2" data-id="element-882" />
                    <span className="text-sm text-gray-500" data-id="element-883">Stück</span>
                  </div>
                </div>)}
              {editedPlan.items.length === 0 && <div className="text-center text-gray-500 py-4" data-id="element-884">
                  Keine Produkte vorhanden
                </div>}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200" data-id="element-885">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-886">
            Abbrechen
          </button>
          <button onClick={() => {
          onSave(editedPlan);
          onClose();
        }} className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-887">
            Speichern
          </button>
        </div>
      </div>
    </div>;
}
function ProductDetailRow({
  item,
  onPrint
}: ProductDetailRowProps) {
  return <div className="pl-8 pr-4 py-3 bg-gray-50 border-t border-gray-200" data-id="element-888">
      <div className="flex items-center justify-between" data-id="element-889">
        <div className="flex items-center gap-3" data-id="element-890">
          <div className="flex items-center gap-2" data-id="element-891">
            <div className="w-4 h-4 rounded-full" style={{
            backgroundColor: item.product.label?.color
          }} data-id="element-892" />
            <span className="text-sm" data-id="element-893">
              {item.product.productNumber} - {item.product.name}
            </span>
          </div>
          <span className="text-sm text-gray-600" data-id="element-894">({item.quantity} Stück)</span>
        </div>
        <button onClick={() => onPrint(item.product, item.quantity)} className="bg-[#ec8301] text-white px-3 py-1.5 text-sm rounded-lg hover:bg-[#ec8301]/90 flex items-center gap-1.5" data-id="element-895">
          <PrinterIcon className="h-4 w-4" data-id="element-896" />
          Nachdrucken
        </button>
      </div>
    </div>;
}
function CodeVerificationModal({
  isOpen,
  onClose,
  action,
  onConfirm
}: {
  isOpen: boolean;
  onClose: () => void;
  action: 'edit' | 'advance' | 'delete';
  onConfirm: () => void;
}) {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = () => {
    if (code === '1234') {
      // In real application, this would be validated against a backend
      setError(false);
      onConfirm(); // This triggers the edit modal
      setCode(''); // Reset the code input
    } else {
      setError(true);
    }
  };
  if (!isOpen) return null;
  const actionText = {
    edit: 'bearbeiten',
    advance: 'vorziehen',
    delete: 'löschen'
  }[action];
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-897">
      <div className="bg-white rounded-lg p-6 w-[400px]" data-id="element-898">
        <div className="flex justify-between items-center mb-4" data-id="element-899">
          <h2 className="text-lg font-medium" data-id="element-900">Supervisor Verifizierung</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-901">
            <XIcon className="h-5 w-5" data-id="element-902" />
          </button>
        </div>
        <p className="text-gray-600 mb-4" data-id="element-903">
          Sie möchten diesen Produktionsplan {actionText}. Bitte geben Sie Ihre
          Supervisor-Nummer ein.
        </p>
        <div className="space-y-4" data-id="element-904">
          <div data-id="element-905">
            <input type="password" value={code} onChange={e => {
            setCode(e.target.value);
            setError(false);
          }} placeholder="Supervisor-Nummer" className={`w-full border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]`} data-id="element-906" />
            {error && <p className="text-red-500 text-sm mt-1" data-id="element-907">
                Ungültige Supervisor-Nummer
              </p>}
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-3" data-id="element-908">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-909">
            Abbrechen
          </button>
          <button onClick={handleSubmit} className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-910">
            Bestätigen
          </button>
        </div>
      </div>
    </div>;
}
export { ProductionPlanning };